module.exports = __webpack_public_path__ + "img/sdglogo.ba6567a2.png";